export interface Alert {
  id: string;
  title: string;
  body: string;
  read: boolean;
  dismissed: boolean;
}
